import React from "react";
 
const ModalSale = ({ isOpen, onClose, children }) => {

    if (!isOpen) return null;
 
    return (
        <>
        <div onClick={onClose} className="modal fade show" tabindex="-1" aria-labelledby="exampleModalLiveLabel" style={{display: 'block'}} aria-modal="true" role="dialog" >
        <div  className="modal-dialog modal-xl modal-dialog-centered" >
        <div className="modal-content" style={{height:"auto"}}>   {/* 1000px */}
              {children}
            </div>
        </div>
        </div>
        <div className="modal-backdrop fade show"></div>
        </>
    );
};
 
export default ModalSale;